import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Varieties
const VarietiesList = () => import(/* webpackChunkName: "varieties" */ '@/views/Varieties/List.vue');
const VarietyCreate = () => import(/* webpackChunkName: "varieties" */ '@/views/Varieties/Create.vue');
const VarietyEdit = () => import(/* webpackChunkName: "varieties" */ '@/views/Varieties/Edit.vue');

let varietiesPages = {
  path: '/varieties',
  redirect: '/varieties',
  component: DashboardLayout,
  name: 'Varieties',
  meta: {
    title: 'Variedades',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'VarietiesList',
      meta: {
        title: 'Listado',
        auth: ['varieties.index'],
      },
      component: VarietiesList,
    },
    {
      path: 'create',
      name: 'VarietyCreate',
      meta: {
        title: 'Nueva',
        auth: ['varieties.store'],
      },
      component: VarietyCreate,
    },
    {
      path: ':id/edit',
      name: 'VarietyEdit',
      meta: {
        title: 'Editar',
        auth: ['varieties.update'],
      },
      component: VarietyEdit,
    },
  ],
};

export default varietiesPages;
